/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 26/04/22
 */

import { weekdaysBetween } from '@/wpt-lib/utils/dateUtils';
import { all, create } from 'mathjs';

const dayDiff = (a: unknown, b: unknown): number => {
    if (!a || !b || typeof a !== 'string' || typeof b !== 'string') {
        return 0;
    }
    return weekdaysBetween(new Date(a), new Date(b));
};

export const toMaxFixed = (num: number, decimals: number): number => {
    return +num.toFixed(decimals);
};

const MathInstance = create(all);
MathInstance.import(
    {
        dayDiff,
        toMaxFixed: toMaxFixed,
    },
    {},
);

export default MathInstance;
